export default __webpack_public_path__ + "static/media/sortDown.1baf1eed.svg";